import createAuth0Client from '@auth0/auth0-spa-js';

type PromiseType<T extends Promise<any>> = T extends Promise<infer R> ? R : void;
export type Auth0Client = PromiseType<ReturnType<typeof createAuth0Client>>;
export const Auth0Client = Symbol.for('Auth0Client');
